export const VOLUNTEER_DASHBOAOD_HERO = {
  USER_MESSAGE: 'Welcome',
  SEARCH: {
    PLACEHOLDER: 'Search for Project Name',
  },
};
